import { colors } from '@/styles/abstracts/colorVariable';

const getColorForEnvironment = (hostname: string): string | undefined => {
  if (hostname.includes('localhost') || hostname.includes('dev1')) {
    return colors.grey['600'];
  }
  if (hostname.includes('dev2')) {
    return colors.grey['700'];
  }
  if (/front\d+\.test/.test(hostname)) {
    return colors.blue['roche-600'];
  }
  if (hostname.includes('test')) {
    return colors.blue['900'];
  }
  if (hostname.includes('staging')) {
    return colors.red['300'];
  }
  return undefined;
};

const setEnvironmentFavicon = () => {
  const hostname = window.location.hostname.toLowerCase();

  // No favicon change for production or customer environment
  if (hostname === 'customer.roche.com') return;

  // Determine favicon color based on environment
  const color = getColorForEnvironment(hostname);

  // If unknown environment, use nothing
  if (!color) return;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="${color}"/></svg>`;
  const dataUri = `data:image/svg+xml,${encodeURIComponent(svg)}`;

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = dataUri;
  document.head.appendChild(link);
};

export default setEnvironmentFavicon;
